import { isValidYamsUrl } from './yams/isValidYamsUrl';
import { isEpsImage } from './eps/isEpsImage';
import { isValidCloudinaryUrl } from './cloudinary/isValidCloudinaryUrl';
/**
 * Checks if an image is hosted internally (by YAMS/EPS).
 * @param url - URL of the checked image
 * @returns True if it is hosted internally
 */
export const isInternalImageUrl = (url) => {
    try {
        return (isValidYamsUrl(new URL(url)) ||
            isEpsImage(url) ||
            isValidCloudinaryUrl(url));
    }
    catch (_) {
        // nop
    }
    return false;
};
